import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class Top {
  /**
   * 申請項目IDから用件と申請項目を取得
   * @param {String} id 申請項目ID
   * @return {Promise<Object>} 条件に合致する用件と申請項目
   */
  getRecItem = async (id, lgCd) => {
    const response = await requestManager.get(`${API_PATH}/v2/top/r/item`, {
      id,
      lgCd,
    });

    return response.data;
  };
}

export default new Top();
